import { render, staticRenderFns } from "./SpringBoardMain.vue?vue&type=template&id=fcf2b24c&"
import script from "./SpringBoardMain.vue?vue&type=script&lang=js&"
export * from "./SpringBoardMain.vue?vue&type=script&lang=js&"
import style0 from "./SpringBoardMain.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports